import styled, { css, keyframes } from 'styled-components';
import { Text } from '~/components/ui/Text';

const pulseAnimation = keyframes`
	0% {
		background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	}
	50% {
		background-color:rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.5);
	}
	100% {
		background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	}
`;

const placeholderPulseAnimation = keyframes`
	0% {
		opacity: 0.25;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0.25;
	}
`;

const StyledContainer = styled.div<{ $active: boolean; $helpHover: boolean }>`
	position: relative;
	width: 60px;
	height: 60px;
	min-width: 60px;
	min-height: 60px;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	transition:
		background-color 0.3s ease,
		border 0.3s ease;
	overflow: hidden;

	${({ $active }) =>
		$active &&
		`
            cursor: grab;
        `}

	.placeholder {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
		margin: 15px 0 0 15px;
		transition: opacity 0.3s ease;

		${({ $active }) =>
			$active &&
			`
            display: none;
        `}
	}

	${({ $helpHover }) =>
		$helpHover &&
		css`
			animation: ${pulseAnimation} 1s infinite;

			.placeholder {
				animation: ${placeholderPulseAnimation} 1s infinite;
			}
		`}
`;

const StyledBootsWrapper = styled.div`
	position: absolute;
	bottom: 2px;
	right: 2px;
	background-color: #121315;
	border-radius: 3px;
`;

const StyledBoost = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 18px;
	padding: 0 2.5px;
	background-color: rgba(0, 255, 55, 0.25);
	border: 1px solid rgba(0, 255, 55, 0.5);
	border-radius: 3px;

	${Text} {
		font-weight: 700;
		font-size: 11px;
		color: #00ff37;
	}
`;

export { StyledBoost, StyledBootsWrapper, StyledContainer };
